module.exports = function(locale, preview, filters) {
  return `fragment PageMetaDataFragment on PageMetaData {
    sys {
      id
    }
    __typename
    pageTitle
    metaTitle
    metaDescription
    metaKeywords
    openGraphPageTitle
    openGraphDescription
    ogImage:openGraphImage{
    url
  }
  }
  
  
  fragment ImageFragment on Image {
    sys {
      id
    }
    name
    altText
    styles
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    image {
      url
      fileName
      contentType
    }
    tooltip
    __typename
  }
  
  fragment ComponentWidthFragment on ComponentWidth {
    sys {
      id
    }
    name
    desktopComponentWidth
    smartphoneComponentWidth
    tabletComponentWidth
  }
  
  fragment HeadingFragment on HeadingTypes {
    sys {
      id
    }
    styles
    headingName
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    heading
    __typename
  }
  
  fragment RichTextFragment on ContentTypeRichText {
    sys {
      id
    }
    __typename
    name
    styles
    body
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
  }
 
  fragment LinkButtonFragment on LinkButton {
    __typename
    sys {
      id
    }
    name
    styles
    link
    linkText
    tooltip
    gaEventClass
    variant
    target
    referencePageCollection(limit: 1) {
      ... on LinkButtonReferencePageCollection {
        items {
          ... on Product {
            sys {
              id
            }
            gtin
            slug
          }
        }
      }
    }
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
  }
  
  fragment ImageButtonFragment on ImageButton {
    sys {
      id
    }
    name
    styles
    altText
    linkText
    link
    tooltip
    gaEventClass
    target
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    image {
      url
      fileName
      contentType
      title
    }
    __typename
  }
  fragment ImageSetFragment on ImageSet {
    sys {
      id
    }
    styles
    __typename
    name
    altText
    desktopImage {
      title
      url
      fileName
      contentType
    }
    tabletImage {
      title
      url
      fileName
      contentType
    }
    smartphoneImage {
      title
      url
      contentType
      fileName
    }
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
  }
  fragment CardFragment on Callout {
    sys {
      id
    }
    __typename
    name
    styles
    variant
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    image {
      __typename
      ...on Image{
        altText
      tooltip
      image {
        title
        url
        fileName
      }
      }
      ...on ImageSet{
        ...ImageSetFragment
      }
    }
    title
    subTitle
    text
    supportingText
    callToActionsCollection(limit: 1) {
      ... on CalloutCallToActionsCollection {
        items {
          
          ... on LinkButton {
            ...LinkButtonFragment
          }
          ... on ImageButton {
            ...ImageButtonFragment
          }
        }
      }
    }
  }
  
  {
    productCollection(limit: 1, locale: "${locale}", preview: ${preview}, where: {slug: "${filters.slug}", sys: {id: "${filters.contentfulId}" }}) {
      items {
        productName
        isNewTemplate
        productShortName
        shortDescription
        productCategoryType
        slug
        breadcrumbTitle
        sitemapTitle
        packshotType 
        alternateText
        minPrice
        maxPrice
        ratingAndReviewId
        gtin
        buyNowType
        disclaimerText
        variantsCollection(limit:5){
          items{
            name
            variantName
            gtin
          }
        }
        pageMetadata {
          ... on PageMetaData {
            ...PageMetaDataFragment
          }
        }
        productImageVideoCollection(limit: 1) {
          items {
            ... on Image {
              ...ImageFragment
            }
          }
        }
        productImage {
          fileName
          url
          description
        }
        heroImage {
          title
          fileName
          url
          contentType
        }
        fecetCollection(limit: 30) {
          items {
            sys {
              id
            }
            name
            title
            facetCategory {
              title
              uniqueId
            }
          }
        }

        faqSectionCollection(limit: 20) {
            items {
            title 
            question
            answer
            }
        }
  
        ingredientsSectionCollection(limit:3) {
          items {
            name
            styles
            componentWidth {
              ...ComponentWidthFragment
            }
            sys{
              id
            }
            sectionContentCollection(limit: 2) {
              items {
                __typename
                ... on ContentTypeRichText {
                  ...RichTextFragment
                }
                ... on HeadingTypes {
                  ...HeadingFragment
                }
                ... on SectionContainer {
                  name
                  styles
                  componentWidth {
                    ...ComponentWidthFragment
                  }
                  sys{
                    id
                  }
                  sectionContentCollection(limit:5){
                    items{
                      __typename
                      ...on Callout{
                        ...CardFragment
                      }
                    }
                  }
                }
              }
            }
          }
        }
        allIngredients
        userInstructions{
          name
          styles
          section1Collection(limit:2){
            items{
              __typename
              ...on HeadingTypes{
                ...HeadingFragment
              }
              ...on Image{
                ...ImageFragment
              }
            }
          }
          section2Collection(limit:2){
            items{
              __typename
              ...on HeadingTypes{
                ...HeadingFragment
              }
              ...on Image{
                ...ImageFragment
              }
            }
          }
          section3Collection(limit:2){
            items{
              __typename
              ...on HeadingTypes{
                ...HeadingFragment
              }
              ...on ContentTypeRichText{
                ...RichTextFragment
              }
            }
          }
        }
        relatedProductsCollection(limit:5){
          items{
            sys{
              id
            }
            productName
            productShortName
            shortDescription
            productCategoryType
            parentPage{
              slug
            }
            slug
            gtin
            variantsCollection(limit:5){
              items{
                name
                variantName
                gtin
              }
            }
            breadcrumbTitle
            heroImage{
              sys{id}
              description
              contentType
              fileName
              url
            }
            ratingAndReviewId  
          }
        }
        
        relatedArticlesCollection(limit: 10) {
          items {
            __typename
            ... on Article {
              sys{
                id
              }
              name
              slug
              title
              cardTitle
              heroImage {
                title
                fileName
                url
                contentType
              }
              parentPage {
                 __typename
              ...on ArticleList{
                slug
                title
              }
              ...on ContentPage{
                slug
                title
              }
              }
            }
          }
        }
        instagramStories {
          ... on Carouselcontainer {
            __typename
            styles
            sys {
              id
            }
            name
            carouselPanelsCollection(limit: 10) {
              items {
                __typename
                ...CardFragment
              }
            }
          }
        }
        pdpCarouselCollection(limit: 1) {
                    items {
                        name
                        pdpImagesCollection(limit: 10) {
                            items {
                                ... on CarouselImages {
                                 carouselImage {
                                  ...ImageSetFragment
                              }
                                    
                                    miniatureImage {
                                    ... on Image {
                                        image { url }
                                        altText
                                    }
                                    }
                                }
                            }
                        }
                    }
                }
                    productDetailsCollection(limit:6) {
                    items {
                        title
                        iconImage {
                            image {url}
                            altText
                        }
                    }
                }
      }
    }
  }
  
  
  `;
};
